// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__Gnobm","tabs":"Navbar_tabs__2lXmc","social":"Navbar_social__LNuaE","title":"Navbar_title__NVFFE"};